import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { MdOutlineNotifications } from "react-icons/md";
import { PopupModal } from "../alert/alert.Dismiss";
import { SEND_CLAIM_BALANCE_ORDER_GROUP } from "../../../graphql/orderGroup/mutation";
import _ from "lodash";


const DropdownClaimBalance = ({ setSelectedIds, isSelectAll, idIn }) => {
    const [content, setContent] = useState('');
    const [gbColor, setBgColor] = useState('');
    const [centered, setCentered] = useState('');
    const [title, setTitle] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const [filter, setFilter] = useState({});


    const handleModal = ({ newTitle, newCentered, newContent, newBgColor }) => {
        setModalShow(true)
        setTitle(newTitle || 'ທວງຍອດລູກຄ້າ');
        setCentered(newCentered);
        setContent(newContent);
        setBgColor(newBgColor);

        // TODO filter
        let newStatus = '';
        switch (newCentered) {
            case "ຍອດເງີນບໍ່ຖືກຕ້ອງ":
                newStatus = 'PAYMENT_STILL_INCOMPLETE'
                break;

            case "ຍັງບໍ່ຊໍາລະ":
                newStatus = 'NO_PAID'
                break;

            case "ແຈ້ງຍອດແຕ່ຍັງບໍ່ຊຳລະ":
                newStatus = 'IMAGE_NOT_YET_PAID'
                break;

            default:
                newStatus = "ALL"
                break;
        }


        const SHOP_ID = localStorage.getItem("SHOP");
        let newFilter = {}

        if (!_.isEmpty(newStatus) && !_.isEmpty(SHOP_ID)) {
            newFilter = {
                ...newFilter,
                shop: SHOP_ID,
                isClaimBalance: false,
                status: newStatus,
            }

            if (!_.isEmpty(idIn)) {
                newFilter = {
                    ...newFilter,
                    id: idIn
                }
            }

            setFilter(newFilter);
        }
    }

    return (
        <>
            <Button
                className="w-100 text-left"
                variant="light"
                disabled={idIn?.length >= 1 ? false : true}
                // style={{ background: COLOR_APP, border: 'none' }}
                onClick={() => handleModal({
                    newCentered: "ທວງທັງຫມົດ",
                    newContent: "ສົ່ງຂໍ້ຄວາມຜ່ານທາງ Messager ເພື່ອທວງຍອດ ສຳລັບອໍເດີທັງຫມົດ: ຍອດເງີນບໍ່ຖືກຕ້ອງ, ຍັງບໍ່ຊໍາລະ, ແຈ້ງຍອດແຕ່ຍັງບໍ່ຊຳລະ", newBgColor: "bg-info text-white"
                })}
            > <MdOutlineNotifications /> ທວງຍອດ</Button>
            <PopupModal
                show={modalShow}
                // onHide={() => { setSelectedIds([]); setModalShow(false) }}
                onCancel={() => { setSelectedIds([]); setModalShow(false) }}
                title={title}
                centered={centered}
                content={content}
                bgColor={gbColor}
                apiPath={SEND_CLAIM_BALANCE_ORDER_GROUP}
                filter={filter}
                ids={idIn}
            />
        </>
    );
};

export default DropdownClaimBalance;
